// Access-token rotation keeps the same session; login, logout and identity changes do not.
export function messageAuthIdentity() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null')
    return localStorage.getItem('token') && user?.identityId != null ? `${user.id || user.userId}:${user.identityId}` : ''
  } catch { return '' }
}
export function messageAuthSession() {
  return JSON.stringify([localStorage.getItem('refreshToken') || localStorage.getItem('token') || '', messageAuthIdentity()])
}
export function currentMessageRequest(config) {
  return config?.messageSession === undefined || config.messageSession === messageAuthSession()
}
export const staleMessageRequest = () => new DOMException('登录身份已切换，请重试', 'AbortError')
